import { DropmenuItemInner } from './style'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons/faAngleDown'

const DropdownItemInner = ({ children, active, ...props }) => {
  return (
    <DropmenuItemInner active={active} {...props}>
      {children}
      <FontAwesomeIcon
        icon={faAngleDown}
        style={{ opacity: active ? 1 : 0, fontSize: '12px', marginLeft: '6px' }}
      />
    </DropmenuItemInner>
  )
}

export default DropdownItemInner
